import { BLITZ_COMMON_LINKS } from 'common/brandMetadata/links/blitzLinks';
import { VERTEX_COMMON_LINKS } from 'common/brandMetadata/links/vertexLinks';
import { clientEnv } from 'common/environment/clientEnv';

const SHARED_LINKS = {
  edge: 'https://app.ar-ca.org/pro/',
  elixir: 'https://app.elixir.finance/',
  zenDesk: 'https://ar-ca.org',
  ethWallets: 'https://ethereum.org/en/wallets/find-wallet/',
  feb13DelistInfo:
    'https://docs.ar-ca.org',
  kado: 'https://kado.money',
  skateFi: 'https://app.skatefi.org/',
  transak: 'https://transak.com',
  twitterTweet: 'https://twitter.com/compose/tweet',
  unlimit: 'https://unlimit.com',
  stats: 'https://app.ar-ca.org/pro/',
};

const STACKD_LINKS = {
  docs: 'https://docs.ar-ca.org',
  discord: 'https://ar-ca.org',
  twitter: 'https://ar-ca.org',
  marketingSite: 'https://ar-ca.org',
  termsOfUse: 'https://ar-ca.org/terms',
  privacyPolicy: 'https://ar-ca.org/privacy',
  maintenanceWindowDocs: 'https://docs.ar-ca.org',
  appStatus: 'https://app.ar-ca.org/pro/',
  spreadDocs: 'https://docs.ar-ca.org',
  isolatedDocs: 'https://docs.ar-ca.org',
  crossChainDocs: 'https://docs.ar-ca.org',
  spotTradingLearnMore: 'https://docs.ar-ca.org',
  fastWithdrawalsLearnMore: 'https://docs.ar-ca.org',
  multipleSubaccountsDocs: 'https://docs.ar-ca.org',
  tutorials: 'https://docs.ar-ca.org',
  faq: 'https://docs.ar-ca.org',
  cookiePolicy: 'https://ar-ca.org/privacy',
  tradingCompetitionDocs: 'https://docs.ar-ca.org',
};

const LINKS_BY_BRAND_NAME = {
  vertex: {
    ...VERTEX_COMMON_LINKS,
    ...SHARED_LINKS,
  },
  blitz: {
    ...BLITZ_COMMON_LINKS,
    ...SHARED_LINKS,
  },
  stackd: {
    ...SHARED_LINKS,
    ...STACKD_LINKS,
  },
};

export const LINKS = LINKS_BY_BRAND_NAME[clientEnv.base.brandName];
